import React, {useState} from 'react'

interface RatingProps {
    name: string,
    onRatingChange: (rating: number) => void;
}

const Rating: React.FC<RatingProps> = ({name, onRatingChange}) => {

    const [rating, setRating] = useState<number | null>(null);
    return <p>
        Your Rating:
        {
            [1, 2, 3, 4, 5].map((value) =>
                (<label key={value}>
                    <input
                        type={"radio"}
                        value={value}
                        checked={rating === value}
                        onChange={(e) => {
                            const selectedRating = parseInt(e.target.value, 10);
                            setRating(selectedRating);
                            onRatingChange(value);
                        }}
                    />
                </label>)
            )
        }  {rating && rating > 0 &&  rating + "/5"}
    </p>;
}


export default Rating;
